import React, {useEffect, useState} from 'react';
import {docStructure} from './docStructure';
import SpriteAnimatedLogo, {SPRITES} from '../../ui/SpriteAnimatedLogo';

const Sidebar = ({ activeSection, onSectionChange, isMobileMenuOpen }) => {
  const [expandedItems, setExpandedItems] = useState({});

  // Auto-expand parent if child is active
  useEffect(() => {
    docStructure.forEach(category => {
      category.items.forEach(item => {
        if (item.children) {
          const hasActiveChild = item.children.some(child => child.id === activeSection);
          if (hasActiveChild) {
            setExpandedItems(prev => ({ ...prev, [item.id]: true }));
          }
        }
      });
    });
  }, [activeSection]);

  const toggleExpanded = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const handleItemClick = (item) => {
    if (item.children) {
      toggleExpanded(item.id);
    } else {
      onSectionChange(item.id);
    }
  };

  return (
    <aside className={`docs-sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <div className="docs-nav">
        <div className="docs-logo">
          <a href="/">
            <SpriteAnimatedLogo width={80} height={80} frameRate={60} autoPlay={false} filename={SPRITES.MEMU_LOGO} />
          </a>
        </div>
        <h3>Documentation</h3>
        {docStructure.map((category, index) => (
          <div key={index} className="docs-category">
            <div className="docs-category-header">
              <i className={`fa-solid ${category.icon}`}></i>
              <span>{category.category}</span>
            </div>
            <div className="docs-category-items">
              {category.items.map(item => (
                <div key={item.id} className="docs-nav-item-container">
                  <button
                    className={`docs-nav-item ${
                      activeSection === item.id ||
                      (item.children && item.children.some(child => child.id === activeSection))
                        ? 'active' : ''
                    } ${item.children ? 'has-children' : ''}`}
                    onClick={() => handleItemClick(item)}
                  >
                    <span>{item.title}</span>
                    {item.children && item.id !== 'memory-operations' && (
                      <i className={`fa-solid ${expandedItems[item.id] ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                    )}
                  </button>
                  {item.children && expandedItems[item.id] && (
                    <div className="docs-nav-subitems">
                      {item.children.map(child => (
                        <button
                          key={child.id}
                          className={`docs-nav-subitem ${activeSection === child.id ? 'active' : ''}`}
                          onClick={() => onSectionChange(child.id)}
                        >
                          {child.icon && <i className={`fa-solid ${child.icon}`} style={{marginRight: '8px'}}></i>}
                          {child.title}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;